import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../api/axios';

export const getCoaches = createAsyncThunk(
  'coaches/getCoaches',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/coaches`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const saveCoach = createAsyncThunk(
  'coaches/saveCoach',
  async ({ data, isUpdate }, { rejectWithValue }) => {
    try {
      let response;
      if (isUpdate.state) {
        response = await securedAxiosInstance.patch(
          `/users/${isUpdate.user.id}`,
          {
            user: data,
          }
        );
      } else {
        response = await securedAxiosInstance.post(`/users`, {
          user: data,
        });
      }

      return { ...response, isUpdate, userData: data };
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const disableCoaches = createAsyncThunk(
  'coaches/disableCoaches',
  async ({ selectedCoaches }, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(`/users/disable_users`, {
        users: { user_id: selectedCoaches },
      });
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);